import { OpenSeaApiResp } from './types'

export const getNFTPlaceholder = (): string => {
  return '/placeholders/NFT-rectangle-placeholder.png'
}

export const openSeaRegex = /^https?:\/\/opensea.io\/assets\/*/

export const getNFTDetail = async (link?: string): Promise<OpenSeaApiResp | void> => {
  const linkDetails = link?.split('/')
  if (!linkDetails || linkDetails?.length <= 1) return
  const assetContractAddressIdx = linkDetails.findIndex(linkDetail => linkDetail?.startsWith('0x'))
  if (!assetContractAddressIdx) return
  const nftAssetId = linkDetails[assetContractAddressIdx]
  if (!nftAssetId) return
  const tokenId =
    linkDetails?.length >= assetContractAddressIdx + 1
      ? linkDetails[assetContractAddressIdx + 1]
      : undefined
  const headers = new Headers()
  headers.append('X-API-KEY', process.env.OPENSEA_API_KEY ?? '')
  try {
    const res = await fetch(
      `https://api.opensea.io/api/v1/assets?asset_contract_addresses=${nftAssetId}${
        tokenId ? `&token_ids=${tokenId}` : ''
      }`,
      {
        headers
      }
    )
    return await res.json()
  } catch (e) {
    console.error('Error fetching NFT Detail', nftAssetId)
  }
}
